import type { PlanGateDecision, PlanGateSeats } from '@easy-expense/utils-shared';
import React from 'react';

import type { MeteredPaywallActions } from '../../hooks/useHandleMeteredAction';

export type PlanGatePrompt = {
  action: MeteredPaywallActions;
  decision: Exclude<PlanGateDecision, 'allowed'>;
  /** This month's count and the free allowance, for metered actions. */
  usage?: { count: number; limit: number };
  onDismiss?: () => void;
};

export type PlanGateValue = {
  hasSubscription: boolean;
  hasProPlanSubscription: boolean;
  seats: PlanGateSeats;
  showPaywall: (prompt: PlanGatePrompt) => void;
};

/** Provided by PlanGateProvider; read through useHandleMeteredAction. */
export const PlanGateContext = React.createContext<PlanGateValue | null>(null);
